// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ab-icon-container {
  display: flex;
  height: 40px;
  width: 40px;
  border-radius: 25px;
  border: 2px solid #5e5e5e;
  background: #ffffff;
  margin: 5px 10px;
  padding: 7.5px;
}
.ab-icon-container img {
  height: 20px;
  width: 20px;
}
.ab-icon-container.icon {
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
}
.ab-icon-container.icon.paper-plane {
  background-image: url('paper-plane.f19d84d4e4fd0c50.svg');
}
.ab-icon-container.icon.mail {
  background-image: url('mail.ba6c75d50b13549d.svg');
}
.ab-icon-container.icon.copy {
  background-image: url('copy.16dd3c253b75bb20.svg');
}
.ab-icon-container.icon.print {
  background-image: url('print.8d464348d91bd152.svg');
}
.ab-icon-container.icon.message {
  background-image: url('message.a4e61c1268ff3c23.svg');
}
.ab-icon-container:hover {
  background-color: #b39841;
  border-color: #b39841;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/action-button/action-button.component.less"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAPA;EAWQ,YAAA;EACA,WAAA;AADR;AAGE;EACE,4BAAA;EACA,2BAAA;EACA,qBAAA;AADJ;AAEI;EACE,yDAAA;AAAN;AAEI;EACE,kDAAA;AAAN;AAEI;EACE,kDAAA;AAAN;AAEI;EACE,mDAAA;AAAN;AAEI;EACE,qDAAA;AAAN;AAII;EACI,yBAAA;EACA,qBAAA;EACA,eAAA;AAFR","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\n.ab-icon-container{\n    display: flex;\n    height: 40px;\n    width: 40px;\n    border-radius: 25px;\n    border: 2px solid @secondary-80;\n    background: @white;\n    margin: 5px 10px;\n    padding: 7.5px;\n\n    img{\n        height: 20px;\n        width: 20px;\n    }\n  &.icon {\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 20px;\n    &.paper-plane {\n      background-image: url(\"../../styles/img/paper-plane.svg\");\n    }\n    &.mail {\n      background-image: url(\"../../styles/img/mail.svg\");\n    }\n    &.copy {\n      background-image: url(\"../../styles/img/copy.svg\");\n    }\n    &.print {\n      background-image: url(\"../../styles/img/print.svg\");\n    }\n    &.message {\n      background-image: url(\"../../styles/img/message.svg\");\n    }\n  }\n\n    &:hover{\n        background-color: @primary-90;\n        border-color: @primary-90;\n        cursor: pointer;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
